<template>
  <Styled>
    <div class="autocomplete-content">
      <div class="icon-search">
        <span class="icon material-icons"> search </span>
      </div>
      <input
        type="search"
        id="search"
        :placeholder="placeholder"
        :name="name"
        class="input"
        :value="getDefaultValue()"
        @input="onInputChange"
        @focus="onFocus"
        @blur="onBlur"
        @keydown="customAction"
      />
      <div :class="`options-container${focus ? ' open' : ''}`">
        <ul
          class="options-ul"
          v-if="
            (focus && Array.isArray(options) && options.length == 0) ||
            isLoading
          "
        >
          <li class="option-item" v-if="isLoading">
            <a class="option-link">Cargando</a>
          </li>
          <li class="option-item" v-if="!isLoading && search.length == 0">
            <a class="option-link">Escriba para buscar...</a>
          </li>
        </ul>
        <ul class="options-ul" v-if="!isLoading">
          <li
            class="option-item"
            v-for="(option, index) in options"
            :value="index"
            :key="index"
          >
            <a
              class="option-link"
              v-on:click="
                Array.isArray(option.children) && option.children.length == 0
                  ? onClickItem(suboption)
                  : () => null
              "
            >
              <span class="icon">
                <svg
                  style="width: 24px; height: 24px"
                  viewBox="0 0 24 24"
                  :class="`arrow-icon ${option.open ? 'open' : 'close'}`"
                >
                  <path
                    fill="currentColor"
                    d="M10,17L15,12L10,7V17Z"
                    v-if="!option.open"
                  />
                  <path
                    fill="currentColor"
                    d="M7,10L12,15L17,10H7Z"
                    v-if="option.open"
                  />
                </svg>
              </span>
              <span class="label"
                >{{ option.label }}
                <span
                  v-if="Array.isArray(option.children)"
                  class="number-resume"
                >
                  ({{ option.children.length }})
                </span></span
              >
            </a>
            <sub-option
              :option="option"
              :onClickItem="onClickItem"
              :node="1"
            ></sub-option>
          </li>
        </ul>
      </div>
    </div>
  </Styled>
</template>

<script>
import Styled from "./styles";
import SubOption from "./SubOption.vue";
import { get as getProp } from "object-path";

export default {
  components: { Styled, SubOption },
  props: ["options", "value", "name", "placeholder", "name", "load-options"],
  data: () => ({
    search: "",
    isLoading: false,
    list: [],
    focus: false,
    interval: null,
  }),
  watch: {
    value: function (value) {
      this.search = getProp(value, "label", "");
    },
    search: function () {
      if (this.search.length == 0) {
        return;
      }
      this.onSearch();
    },
  },
  mounted() {},
  methods: {
    onInputChange(e) {
      const { value } = e.target;
      this.search = value;
    },
    getDefaultValue() {
      return this.search.trim() != ""
        ? this.search
        : getProp(this.value, "label");
    },
    customAction(event) {
      const code = event.which || event.keyCode;
      if (code == 27) {
        this.focus = false;
      }
    },
    queryForKeywords(event) {
      const value = event.target.value;
      this.keywords = value;
    },
    onKeyDown(event) {
      console.log(event);
    },
    onFocus() {
      this.focus = true;
    },
    onBlur() {
      setTimeout(() => {
        this.focus = false;
      }, 200);
    },
    onClickItem(item) {
      this.focus = false;
      this.$emit("input", item);
    },
    onFinish(event, cities) {
      this.isLoading = false;
    },
    onSearch() {
      const search = this.search;
      this.isLoading = true;
      if (this.interval) {
        clearTimeout(this.interval);
      }
      this.interval = setTimeout(() => {
        this.$emit("getCities", {
          action: "ASYNC_SEARCH",
          searchQuery: search,
          callback: (event, cities) => this.onFinish(event, cities),
        });
      }, 500);
    },
  },
};
</script>
